import { graphql, useStaticQuery } from 'gatsby';
import { useTranslation } from 'gatsby-plugin-react-i18next';
import React from 'react';
import { Seo } from 'src/components';
import { RichText } from 'src/helpers';
import InfoPagesLayout from 'src/layouts/InfoPagesLayout';
import { Paragraph, PricacyAndTerms, PricacyAndTermsContainer } from 'src/styles/infoPages';

const paragraphStyles: React.CSSProperties = { textAlign: 'start' };

interface PrivacyPolicyProps {
  mobileLayout: boolean;
}

const PrivacyPolicy: React.FC<PrivacyPolicyProps> = ({ mobileLayout }) => {
  const { t } = useTranslation();

  const data = useStaticQuery(graphql`
    query PrivacyPolicyQuery {
      allContentfulPrivacyPolicy {
        edges {
          node {
            privacyPolicy {
              raw
            }
          }
        }
      }
    }
  `);
  const { privacyPolicy } = data?.allContentfulPrivacyPolicy?.edges[0]?.node;

  const content = (
    <PricacyAndTermsContainer>
      <PricacyAndTerms>
        <Paragraph style={paragraphStyles}>
          <RichText content={privacyPolicy} styledLink={false} />
        </Paragraph>
      </PricacyAndTerms>
    </PricacyAndTermsContainer>
  );

  return mobileLayout ? (
    <div>{content}</div>
  ) : (
    <>
      <InfoPagesLayout title={'privacyPolicy.title'}>{content}</InfoPagesLayout>
      <Seo title={t('jonniName') + ' - ' + t('privacyPolicy.title')} />
    </>
  );
};

export default PrivacyPolicy;
